<template>
    <td>
        <b-btn v-tooltip="'Törlöm az aktualis sort'"
               v-on:click="deleteKetRow()"
               class='btn btn-sm  btn-danger btn-block btn-delete-row'>
            <i class="fa fa-trash "
               style="color:white"></i>
        </b-btn>
    </td>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: ["ketId", "ketRowId"],

  data() {
    return {
      form: new Form({
        ketRowId: ""
      })
    };
  },

  methods: {
    deleteKetRow() {
      swal({
        title: "Biztosan törlöd ezt a sort?",
        text: "Nem lehet kesőbb visszavonni ezt a műveletet!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen, törlöm!",
        confirmButtonColor:"#a50707",
        cancelButtonText: "Nem, megtartom"
      }).then(result => {
        if (result.value) {
          this.form.ketRowId = this.ketRowId;
          this.form
            .post("ajax/kets/deleteKetRow")
            .then(status =>
              this.$emit("deletedKetRow", status, this.ketId, this.ketRowId)
            )
            .catch(e => {
              swal("Hiba!", "Probáld újra később :)", "error");
            });
        } else if (result.dismiss === "cancel") {
             swal(
            {
              type: "error",
              title: "Rendben!",
              html: "A törlés megszakítva.",
              confirmButtonColor:"#3fa535",
              confirmButtonText:"Rendben"
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DeleteKetRow.vue